import {
  ActionValidation,
  BooleanValidation,
  NumberValidation,
  StringValidation,
} from '../../../utils/component-validations';
import { or } from 'ember-truth-helpers';
import CharacterCounter from '../core/character-counter.gjs';
import Container from '../core/container.gjs';
import HelperText from '../core/helper-text.gjs';
import LabeledBase from './labeled/base.gjs';
import Super from '../core/base.gjs';
import styles from './text.module.scss';

export default class SpdsInputText extends Super {
  arguments = [
    new ActionValidation({ required: ['onInput'] }),
    new BooleanValidation({ optional: ['error', 'required'] }),
    new NumberValidation({ optional: ['charLimit'] }),
    new StringValidation({ optional: ['helperText', 'label', 'name', 'placeholder'] }),
  ];
  baseClass = 'spds-input-text';
  componentName = 'Spds::Input::Text';
  styles = styles;

  get characterCounterId() {
    return this.composeSubcomponentId('character-counter');
  }

  get helperTextId() {
    return this.composeSubcomponentId('helper-text');
  }

  get showAdditionalText() {
    let { charLimit, helperText } = this.args;

    return charLimit || helperText;
  }

  <template>
    <Container @column={{true}} class={{this.styles.container}}>
      <LabeledBase
        @additionalArguments={{this.arguments}}
        @ariaLabel={{@ariaLabel}}
        @autofocus={{@autofocus}}
        @component={{this.componentName}}
        @disabled={{@disabled}}
        @error={{@error}}
        @id={{this.id}}
        @maxLength={{@charLimit}}
        @name={{@name}}
        @onInput={{@onInput}}
        @placeholder={{@placeholder}}
        @required={{@required}}
        @type="text"
        @value={{@value}}
        class={{this.classes}}
        data-test-spds-text-input={{this.id}}
        {{this.validateArguments}}
        ...attributes
      >
        <Container @content={{@label}} class="spds-text-input-label-container">
          {{yield to="label"}}
        </Container>
      </LabeledBase>
      {{#if (or this.showAdditionalText (has-block "helper-text"))}}
        <Container class="spds-text-input-additional-text-container">
          <HelperText
            @error={{@error}}
            @helperText={{@helperText}}
            @id={{this.helperTextId}}
            class="spds-text-input-helper-text"
            data-test-spds-text-input-helper-text={{this.id}}
          >
            {{yield to="helper-text"}}
          </HelperText>
          {{#if @charLimit}}
            <CharacterCounter
              @id={{this.characterCounterId}}
              @limit={{@charLimit}}
              @value={{@value}}
              data-test-spds-text-input-char-count={{this.id}}
            />
          {{/if}}
        </Container>
      {{/if}}
    </Container>
  </template>
}
